import React from 'react'
import { Typography, Container, TooltipV2 } from '@cleartrip/ct-design-components'
import { filterTypes } from '@/constants/Srp'
import { FilterData as FilterDataType, PossibleFilterTypes } from '@/types/srp'
import { formatCurrency } from '@/utils'
import { isValidPrice } from '@/utils/general'
import CheckboxItem from './checkboxItem'
import FilterJourneyInfo from './FilterJourneyInfo'

type OptionType = {
  label: string
  value: string
  subLabel: string
  priceLabel?: number
  priceLabelADT?: number
}

type NearbyAirportFilterProps = {
  nearbyAirportFilter: {
    options: OptionType[]
    selectedValues: string[]
    airportCode: string
  }[]
  onFilterChange: (type: PossibleFilterTypes, filtersData: FilterDataType, selectedIndex: number) => void
  isPerAdultPricing?: boolean
  from?: string
  to?: string
  isRT?: boolean
  isRevamp?: boolean
}

const NearbyAirportFilter = ({
  nearbyAirportFilter,
  onFilterChange,
  isPerAdultPricing = true,
  from,
  to,
  isRT,
  isRevamp = false,
}: NearbyAirportFilterProps) => {
  const onNearbyAirportClick = (option: OptionType, airportIndex: number, currentSelectedValues: string[]) => {
    let updatedNearbyAirportSelectedValues
    const { value } = option
    if (currentSelectedValues.includes(value)) {
      updatedNearbyAirportSelectedValues = currentSelectedValues.filter(selectedValue => value !== selectedValue)
    } else {
      updatedNearbyAirportSelectedValues = [...currentSelectedValues, value]
    }
    onFilterChange(filterTypes.NEARBY_AIRPORT, updatedNearbyAirportSelectedValues, airportIndex)
  }

  const getPriceForOption = (option: OptionType) => {
    const price = isPerAdultPricing ? option.priceLabelADT : option.priceLabel
    return isValidPrice(price) ? formatCurrency(String(price)) : null
  }

  const priceVariant = isRevamp ? 'P3' : 'P2'
  const checkboxWrapperClassName = isRevamp ? 'py-2 w-100p checkbox-hover-border' : 'my-2 w-100p checkbox-hover-border'

  return (
    <Container className={isRevamp ? 'flex flex-column' : 'flex flex-column py-3'}>
      <FilterJourneyInfo from={from || ''} to={to || ''} isRT={!!isRT} isRevamp={isRevamp} legacyVariant='L2' />
      {nearbyAirportFilter?.map(({ options, selectedValues }, airportIndex) => {
        return options?.map(option => {
          const { value, label } = option
          const checked = selectedValues.includes(value)
          const price = getPriceForOption(option)
          return (
            <CheckboxItem
              key={`${airportIndex}-${value}`}
              label={
                <TooltipV2
                  position='bottom'
                  labelContainer={
                    <Container className='flex flex-between flex-gap-4 w-100p'>
                      <Typography
                        variant='P2'
                        className='c-pointer t-truncate'
                        style={{ maxWidth: '150px', whiteSpace: 'nowrap' }}
                      >
                        {label}
                      </Typography>

                      <Typography variant={priceVariant} className='c-pointer' color='subheading'>
                        {price}
                      </Typography>
                    </Container>
                  }
                  styleConfig={{
                    root: {
                      className: 'w-100p',
                    },
                    labelContainer: {
                      className: 'w-100p',
                    },
                    tooltipContainer: {
                      className: ' l-0',
                    },
                    tooltipArrowContainer: {
                      css: { left: '12px' },
                    },
                  }}
                >
                  <Typography variant='B4' className='ws-nowrap p-2' color='neutral'>
                    {label}
                  </Typography>
                </TooltipV2>
              }
              checked={checked}
              onClick={() => onNearbyAirportClick(option, airportIndex, selectedValues)}
              wrapperClassName={checkboxWrapperClassName}
              rootClassName='w-100p'
            />
          )
        })
      })}
    </Container>
  )
}

export default NearbyAirportFilter
